import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import css from './Trust.module.css';

/**
 * The standard PostPartners applies before a provider is listed.
 */
const Trust = () => (
  <section className={css.root}>
    <div className={css.inner}>
      <h2 className={css.title}>
        <FormattedMessage id="AboutTrust.title" defaultMessage="Trust is the product" />
      </h2>
      <p className={css.stand}>
        <FormattedMessage
          id="AboutTrust.stand"
          defaultMessage="We don't just list providers. We vet them. We stand behind them."
        />
      </p>
      <p className={css.text}>
        <FormattedMessage
          id="AboutTrust.text"
          defaultMessage="We've built a platform that makes booking, communicating, and paying for postpartum care as seamless as the care itself should be. For families, that means peace of mind at the moment you need it most. For providers, that means a platform that values their expertise, protects their work, and connects them with families who are ready to invest in their recovery."
        />
      </p>
    </div>
  </section>
);

export default Trust;
